import type { CSSProperties, ReactNode } from "react";

import { sx } from "../style";

export interface EmptyStateProps {
  icon?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  compact?: boolean;
  style?: CSSProperties;
}

/** Placeholder for empty/zero-data states. */
export function EmptyState({
  icon,
  title = "Немає даних",
  description,
  action,
  compact = false,
  style,
}: EmptyStateProps) {
  return (
    <div
      style={sx({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: compact ? "32px 24px" : "56px 32px",
        gap: 4,
        ...style,
      })}
    >
      <div
        style={sx({
          width: compact ? 44 : 56,
          height: compact ? 44 : 56,
          borderRadius: "var(--radius-lg)",
          background: "var(--blue-50)",
          color: "var(--color-brand-primary)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 12,
        })}
      >
        {icon || (
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
            <path d="M9 3h6l4 4v14H5V3z" strokeLinejoin="round" />
            <path d="M14 3v5h5" />
            <path d="M9 13h6M9 17h4" strokeLinecap="round" />
          </svg>
        )}
      </div>
      <div style={sx({ fontSize: "var(--fs-subtitle)", fontWeight: "var(--fw-semibold)", color: "var(--color-text-primary)" })}>
        {title}
      </div>
      {description && (
        <div
          style={sx({
            fontSize: "var(--fs-body-sm)",
            color: "var(--color-text-secondary)",
            maxWidth: 360,
            lineHeight: "var(--lh-body)",
          })}
        >
          {description}
        </div>
      )}
      {action && <div style={{ marginTop: 16 }}>{action}</div>}
    </div>
  );
}
